import React, { useState } from "react";
import Drawer from "react-drag-drawer";
import FormCallUs from "./faleconosco-form/index";

const CallUsModal = ({
  show_callus,
  toggle_callus,
  isSuccess,
  setIsSuccess,
  appState
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Drawer dontApplyListeners={true} open={show_callus} onRequestClose={() => toggle_callus(false)}>
      <div className="modal modal-callus">
        <div className="modal-container-callus">
          <h2 style={{ padding: 10, marginBlockEnd: 0 }}>FALE CONOSCO</h2>
          <p style={{ padding: 10, margin: 0 }}>
            Ficou com alguma dúvida ou quer dar sua opinião? Então banque o autor e escreva para nós!
          </p>
          <FormCallUs
            toggle_callus={toggle_callus}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
            appState={appState}
          />
          <p style={{ padding: 10 }}>
            A gente vai responder o mais rápido que puder.
          </p>
        </div>
      </div>
    </Drawer>
  );
};
export default CallUsModal;